import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import axios from 'axios';
import SocialMediaScheduler from './SocialMediaScheduler';
import PlatformConnections from './PlatformConnections';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';
import { BACKEND_URL } from './config';

const App = () => {
const [user, setUser] = useState(null);

const checkLogin = async () => {
    try {
    const response = await axios.get(`${BACKEND_URL}/api/check-login`, {
        withCredentials: true,
    });
    setUser(response.data.userId ? { id: response.data.userId } : null);
    } catch (error) {
    console.error('Error checking login status:', error);
    setUser(null);
    }
};

useEffect(() => {
    checkLogin();
}, []);

return (
    <Router>
    <div>
        <h1 className="app-title">UrPoster</h1>
        <Routes>
        <Route
            path="/login"
            element={<SocialMediaScheduler onLogin={checkLogin} />}
        />
        <Route
            path="/register"
            element={<SocialMediaScheduler onLogin={checkLogin} />}
        />
        <Route
            path="/dashboard"
            element={user ? <PlatformConnections /> : <Navigate to="/login" />}
        />
        <Route
            path="/scheduler"
            element={<SocialMediaScheduler onLogin={checkLogin} />}
        />
        <Route path="/" element={<Navigate to="/scheduler" />} />
        <Route path="/privacy" element={<TermsOfService />} />
        <Route path="/terms" element={<PrivacyPolicy />} />
        </Routes>
    </div>
    </Router>
);
};

export default App;
